import React from "react"
import Box from "@material-ui/core/Box"
import ReactQuill from "react-quill"
import "react-quill/dist/quill.snow.css"
import "react-quill/dist/quill.bubble.css"
import PropTypes from "prop-types"

import { compose, defaultProps, withHooks } from "enhancers"

const Editor = ({ layoutProps, editorProps }) => (
  <Box {...layoutProps}>
    <ReactQuill {...editorProps} />
  </Box>
)

const enhancer = compose(
  defaultProps({
    theme: "snow",
  }),
  withHooks((props, hooks) => {
    const { form, field, theme, placeholder, ...rest } = props
    const { useMemo, useCallback } = hooks

    const { setFieldValue } = form
    const { name, value } = field

    const layoutProps = rest

    const onChange = useCallback(
      (value) => {
        setFieldValue(name, value)
      },
      [setFieldValue, name],
    )

    const editorProps = useMemo(() => {
      return {
        theme,
        placeholder,
        onChange,
        value: value ?? "",
      }
    }, [theme, placeholder, onChange, value])

    return {
      layoutProps,
      editorProps,
    }
  }),
)

Editor.propTypes = {
  layoutProps: PropTypes.any.isRequired,
  editorProps: PropTypes.any.isRequired,
}

export default enhancer(Editor)
